"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const Flex_1 = __importDefault(require("components/shared-2/Flex"));
const Switcher = ({ options, onChange = () => null, selectedOption = '', fullWidth = false, isReadOnly, customClass = '', textCustomClass = '' }) => {
    const SwitcherCN = (fullWidth) => {
        return (0, classnames_template_literals_1.default)(`
    cursor-pointer
    ${fullWidth ? 'w-full' : 'width-fit-content'}
    ${customClass}
  `);
    };
    const SwitcherItemCN = (firstItem, lastItem, selected) => {
        return (0, classnames_template_literals_1.default)(`
      bg-n-000
      py-[8px]
      px-[16px]
      ${fullWidth ? 'w-full' : ''}
      text-center
      border
      border-solid
      ${firstItem ? 'rounded-l-[4px]' : '-ml-[1px]'}
      ${lastItem ? 'rounded-r-[4px]' : ''}
      ${selected
            ? `
        z-[2]
        !bg-base-3008
        !text-base-600
        !border-base-600
        active
        `
            : 'border-n-400'}
      ${isReadOnly
            ? `!bg-n-100
          hover:cursor-not-allowed
        `
            : `
        hover:bg-base-3008
        hover:text-base-600
        hover:border-base-600
        `}
    `);
    };
    return (react_1.default.createElement("div", { className: SwitcherCN(fullWidth) },
        react_1.default.createElement(Flex_1.default, { align: "center", justify: "evenly" }, options.map((opt, index) => (react_1.default.createElement("div", { key: index, "data-cy": opt.id, onClick: (e) => {
                e.stopPropagation();
                !isReadOnly && onChange(opt.id);
            }, className: SwitcherItemCN(index === 0, options.length - 1 === index, selectedOption === opt.id) },
            react_1.default.createElement("p", { className: textCustomClass }, (0, HelperUtils_1.getObjectiveLocale)(opt.name))))))));
};
exports.default = Switcher;
